import { render, staticRenderFns } from "./ProductosClone.vue?vue&type=template&id=3f1e3d0e&"
import script from "./ProductosClone.vue?vue&type=script&lang=js&"
export * from "./ProductosClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports